// src/pages/Trader/OrdersAndWithdrawals/Applications/page/Applications.tsx

import React, { useState } from 'react';
import './Applications.css';
import { useRecoilState } from 'recoil';

// Общий контейнер для страниц
import { MainContainer } from '../../../../../components/MainContainer/MainContainer';

// Блоки «get_self» (ставка и статистика)
import SelfRates from '../../components/SelfRate/SelfRates';
import SelfStats from '../../components/SelfState/SelfStats';

// Модал «Пополнение» (наш CreateOrder)
import { CreateOrder } from '../components/CreateOrder/CreateOrder';
import { CreateWithdrawal } from '../components/CreateWithdrawal/CreateWithdrawal';
import { CreateReport } from '../components/CreateReport/CreateReport';
import { CreateDispute } from '../components/CreateDispute/CreateDispute';
import CustomFilterModal, { FilterValues } from '../components/CustomFilterModal/CustomFilterModal';
// Основной контент (таблица или карточки «Заявок»)
import { Content } from '../components/Content/Content';

export const Applications = () => {
  const [isCreateOrderOpen, setIsCreateOrderOpen] = useState(false);
  const [isCreateWithdrawalOpen, setIsCreateWithdrawalOpen] = useState(false);
  const [isCreateReportOpen, setIsCreateReportOpen] = useState(false);
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [filterVals,       setFilterVals]     = useState<FilterValues | null>(null);

  return (
    <MainContainer>
      <div className="applications merchant-page">
        <header className="merchant-page__header">
          <div>
            <span className="merchant-page__eyebrow">ОПЕРАЦИИ</span>
            <h1>Заявки</h1>
            <p>Пополнения, выплаты и их текущие статусы</p>
          </div>
        </header>
        <SelfRates />
        <SelfStats />

        <div className="merchant-toolbar">
          <button
            onClick={() => {
              setIsCreateOrderOpen(true);
            }}
            className="merchant-button merchant-button--primary"
          >
            + Пополнение
          </button>

          <button
            onClick={() => {
              setIsCreateWithdrawalOpen(true);
            }}
            className="merchant-button merchant-button--danger"
          >
            + Вывод
          </button>
          <div className="merchant-toolbar__spacer" />
              <button
                type="button"
                aria-label="Фильтр"
                onClick={() => setFilterOpen(true)}
                className="merchant-icon-button"
              >
                <img
                  src="/filter.svg"
                  alt="Фильтр"
                  className="merchant-icon-button__image"
                />
              </button>

              <button
                type="button"
                aria-label="Скачать"
                onClick={() => setIsCreateReportOpen(true)}
                className="merchant-icon-button"
              >
                <img
                  src="/download.svg"
                  alt="Скачать"
                  className="merchant-icon-button__image"
                />
              </button>
        </div>

        {/* Модалки */}
        <CreateOrder
          open={isCreateOrderOpen}
          onClose={() => setIsCreateOrderOpen(false)}
        />
        <CreateWithdrawal
          open={isCreateWithdrawalOpen}
          onClose={() => setIsCreateWithdrawalOpen(false)}
        />

        <CreateReport
          open={isCreateReportOpen}
          onClose={() => setIsCreateReportOpen(false)}
        />


        <CustomFilterModal
          isOpen={isFilterOpen}
          onClose={() => setFilterOpen(false)}
          onApply={vals => {
            setFilterVals(vals);
            setFilterOpen(false);
          }}
        />
        {/* 4) Заголовок и список заявок */}
        <h2 className="merchant-section-title">История заявок</h2>
        <Content filter={filterVals} />
      </div>
    </MainContainer>
  );
};
